



































import { Vue, Component } from 'vue-property-decorator';
import Form from '@/helpers/Form';
import AuthService from '@/services/core/AuthService';

@Component({})
export default class ForgotPassword extends Vue
{
    private message: string = ''
    private messageVariant: string = 'danger';
    private callbackUrl: string = '';
    private form: Form<any> = Form.create<any>({
        email: ''
    });

    created()
    {
        this.callbackUrl = this.getAbsoluteUrl(this.$router.resolve({
            name: 'reset-password',
            params: { token: ':token' }
        }).href);
    }

    async onSubmit()
    {
        this.message = '';

        try
        {
            this.form.wait();

            let result = await AuthService.resetPassword(
                this.form.email,
                this.callbackUrl
            );

            this.messageVariant = 'success';
            this.message = result;
            this.form.email = '';
        }
        catch (ex)
        {
            this.handleException(ex, {
                400: (ex: any) => { this.messageVariant = 'danger'; this.message = ex.message; },
                422: (ex: any) => this.form.$errors.record(ex.data.errors)
            });
        }
        finally
        {
            this.form.continue();
        }
    }

    getAbsoluteUrl(href: string)
    {
        var defaultPorts: any = { "http:": 80, "https:": 443 };

        return window.location.protocol + "//" + window.location.hostname + (
            ((window.location.port) && (window.location.port !== defaultPorts[window.location.protocol])) ? (":" + window.location.port) : ""
        ) + href;
    }
}
